<div class="container-fluid cld-full-height cld-full-width-rectangle sk-login-div-body" *ngIf="accessTokenService.showLoginUI"
    style="display: flex; justify-content: center; align-items: center;">
    <div class="section cld-full-height">
        <div class="">
            <div class="login-div">
                <mat-card class="pt-3 pr-5 pb-4 pl-5 solid-bg height-fit-content"
                    [class.sk-lg--sso-only]="!passwordLoginEnabled">
                    <div class="align-item-center" *ngIf="spendkeyLoadLogo">
                        <!-- <img class="pb-4 img-css" src="assets/new-icons/Spendkey_logo_dark.svg"> -->
                        <!-- <img  width="250px" height="68px" class="pb-4" [src]="loginLogo"> -->
                        <img class="pb-4 img-css" [ngClass]="spendkeyFav ? 'sk-logo-client' : 'sk-logo-default' "
                            [src]="loginLogo">
                    </div>
                    <!-- <div *ngIf="spendkeyFav">
                        <span style="display: flex; justify-content: flex-end;" class="txt-font-family-sign-in">{{ 'Provided by Spendkey' | translate }}</span>
                    </div> -->
                    <div *ngIf="errorAlert" class="w3-panel w3-red">
                        <p>{{errorMessage}}</p>
                    </div>
                    <div class="row mb-4" *ngIf="!spendkeyFav">
                        <div class="col-12 align-center login-subheading">
                            <span class="txt-font-family-sign-in"> {{ 'Log in to Spendkey' | translate }} </span>
                        </div>
                    </div>

                    <!-- Hidden on an SSO-only deployment, and until passwordLogin is known. -->
                    <ng-container *ngIf="passwordLoginEnabled && passwordLoginResolved">
                    <div class="row mt-4">
                        <div class="col-12">
                            <!-- Login form -->
                            <form [formGroup]="loginFormGroup" (keydown.enter)="onLoginSubmit()">
                                <div class="form-group">
                                    <div class="input-group">
                                        <span class="spendkey-Email align-in-input"></span>
                                        <!-- Email field -->
                                        <input type="text" formControlName="email"
                                            class="form-control input-text login-input" [placeholder]="'Work Email' | translate"
                                            [ngClass]="{ 'is-invalid': submitted && loginFormGroup.controls['email'].errors }" />
                                        <div *ngIf="submitted && loginFormGroup.controls['email'].errors"
                                            class="invalid-feedback bg-color login-error">
                                            <div style="font-size: 11px;"
                                                *ngIf="loginFormGroup.controls['email'].errors['required']">{{ 'Please enter valid email!' | translate }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group pt-2">
                                    <div class="input-group sk-spendkey-Passowrd">
                                        <span class="spendkey-Passowrd align-in-input"></span>
                                        <!-- Password field -->
                                        <input #pwd [type]="fieldTextType ? 'text' : 'password'"
                                            formControlName="password" maxlength="25"
                                            class="form-control input-text login-input" [placeholder]="'Password' | translate"
                                            [ngClass]="{ 'is-invalid': submitted && loginFormGroup.controls['password'].errors }" />
                                        <span class="sk-lg-eye btn btn-default align-eye-icon"
                                            [ngClass]="fieldTextType ? 'spendkey-Password-show' : 'spendkey-hide'"
                                            (click)="togglePassword()"></span>
                                        <div *ngIf="submitted && loginFormGroup.controls['password'].errors"
                                            class="invalid-feedback bg-color login-error">
                                            <div style="font-size: 11px;"
                                                *ngIf="loginFormGroup.controls['password'].errors['required']">{{ 'This is required field!' | translate }}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row sk-login-page-frgt-pass">
                                    <div class="sk-login-page-frgt-pass-inn">
                                        <a routerLink="/forgot-password">
                                            <span>
                                                {{ 'Forgot password' | translate }}
                                            </span>
                                        </a>
                                    </div>
                                </div>

                                <!-- <div class="align-txt-terms">
                                    <span class="txt-font-family-terms">{{ 'By clicking "Sign in" you confirm that you accept the' | translate }} <a href="#" style="color:var(--sk-color-accent);">{{ 'Terms and Conditions' | translate }}</a> {{ 'and' | translate }} <a
                                            href="#" style="color:var(--sk-color-accent);">{{ 'Privacy Policy.' | translate }}</a></span>
                                </div> -->
                                <button
                                    mat-raised-button
                                    type="button"
                                    class="cld-full-width mb-2 mt-2 sendkey-primary"
                                    (click)="onLoginSubmit()">
                                    {{ 'Log in' | translate }}
                                </button>
                            </form>
                        </div>
                    </div>

                    <div class="row sk-mb-3 sk-or-continue-with-text">
                        <div class="col sk-text-center">
                            <div class="sk-mt-3 sk-mb-3"> <span>{{ 'Or continue with' | translate }}</span> </div>
                        </div>
                    </div>
                    </ng-container>
                    <div class="row mt-2 mb-4" [class.sk-lg-sso__providers]="!passwordLoginEnabled">
                        <span class="sk-sso-error">{{loginSsoErrorMessage}}</span>
                        <ng-container *ngIf="!ssoProvidersLoading; else ssoSkeleton">
                            <div class="col mb-1" *ngIf="pingProvider">
                                <div class="align-item-center">
                                    <button type="button" (click)="onPingSignOn()" mat-raised-button
                                        class="sk-full-width google-ms-btn"><img
                                            [class.sso-tenant-logo]="!!pingProvider.logoUrl"
                                            [alt]="pingProvider.logoUrl ? 'Sign in with single sign-on' : 'Sign in with Ping Identity'"
                                            [src]="pingProvider.logoUrl || '../../assets/svg/ping-logo.svg'" /></button>
                                </div>
                            </div>
                            <div class="col mb-1" *ngIf="showOktaButton">
                                <div class="align-item-center">
                                    <button type="button" (click)="onOktaSignOn()" mat-raised-button
                                        class="sk-full-width google-ms-btn"><img alt="Okta" height="18"
                                            src="../../assets/svg/okta-svg.svg" />&nbsp;<span
                                            class="sk-ext-provider-btn-text"> {{ passwordLoginEnabled ? ('Okta' | translate) : ('Continue with' | translate) + ' Okta' }} </span> </button>
                                </div>
                            </div>
                            <div class="col mb-1" *ngIf="showMicrosoftButton">
                                <div class="align-item-center">
                                    <button type="button" (click)="onSingleSignOn()" mat-raised-button
                                        class="sk-full-width google-ms-btn"><img alt="Microsoft" height="18"
                                            src="../../assets/svg/logo_microsoft.svg" />&nbsp;<span
                                            class="sk-ext-provider-btn-text"> {{ passwordLoginEnabled ? ('Microsoft' | translate) : ('Continue with' | translate) + ' Microsoft' }} </span></button>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #ssoSkeleton>
                            <!--
                                Placeholder pills while the tenant's providers list resolves.
                                Reserves the same row height as the real buttons so the
                                layout doesn't shift when the descriptors arrive.

                                role="status" + aria-busy makes the loading state a live
                                region (WCAG 2.1 SC 4.1.3) so screen-reader users hear that
                                sign-in options are loading; the individual pills stay
                                aria-hidden because they're purely decorative.
                            -->
                            <div role="status" aria-busy="true"
                                [attr.aria-label]="'Loading sign-in options' | translate">
                                <div class="col mb-1" *ngFor="let _ of [0, 1, 2]">
                                    <div class="sk-sso-skeleton" aria-hidden="true"></div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                    <div class="col sk-tnc-pp-contet-login">
                        <div class="sk-login-form-terms">
                            <span class="">{{ (passwordLoginEnabled ? 'By clicking "Log in" you confirm that you accept the' : 'By signing in you confirm that you accept the') | translate }} <span class="sk-terms-link" (click)="viewTerms();">{{ 'Terms and Conditions' | translate }}</span> {{ 'and' | translate }} <span class="sk-terms-link" (click)="viewPolicy();">{{ 'Privacy Policy.' | translate }}</span></span>
                        </div>
                    </div>

                    <!-- <div class="sk-demo-divider"></div>
                    <div class="sk-demo-row">
                        <span class="sk-demo-text">{{ 'New to Spendkey?' | translate }}</span>
                        <a routerLink="/company-onboarding" class="sk-demo-link">{{ 'Request a Demo' | translate }}</a>
                    </div> -->
                </mat-card>
            </div>
        </div>
    </div>
</div>
